<script>
import { Bar } from 'vue-chartjs';

export default {
  components: { Bar },
  extends: Bar,
  props: ['chartData'],
  methods: {
    render() {
      this.renderChart(this.chartData, {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              id: 'y-bars',
              stacked: false,
              gridLines: {
                display: true,
              },
              ticks: {
                callback: function (value, index, values) {
                  return value.toLocaleString('sv-SE', {
                    maximumFractionDigits: 0,
                  });
                },
                min: 0,
              },
            },
            {
              display: false,
              ticks: {
                min: 0,
              },
              id: 'y-lines',
              stacked: false,
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: false,
          position: 'right',
          labels: {
            usePointStyle: false,
            boxWidth: 20,
            fontSize: 12,
          },
        },
        tooltips: false,
      });
    },
  },
  watch: {
    chartData: function () {
      this.render();
    },
  },
  mounted() {
    this.render();
  },
};
</script>

<style scoped>
.bar-chart-container {
  height: 400px;
}
</style>
